/**
 * Per-browser UI preferences (rail state, tour progress). Never secrets, never shared; every access
 * is wrapped because storage can be unavailable (private windows, blocked site data).
 */
export function readPref(key: string, store?: Storage): string | null {
  try {
    return (store ?? localStorage).getItem(key);
  } catch {
    return null;
  }
}

export function writePref(key: string, value: string | null, store?: Storage): void {
  try {
    const s = store ?? localStorage;
    if (value === null) s.removeItem(key);
    else s.setItem(key, value);
  } catch {
    /* storage unavailable: the preference lasts for this page only */
  }
}
